import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return data?.map(cm => ({
      id: cm.email.address,
      text: cm.email.address,
      description: cm.description,
    }))
  }, [data])
}
